import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const customFieldsApi = createApi({
  reducerPath: 'customFieldsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['CustomFields'],
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    updateCustomField: builder.mutation({
      query: ({ id, body }) => ({
        url: `/customField/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['CustomFields'],
    }),
  }),
});

export const { useUpdateCustomFieldMutation } = customFieldsApi;
